(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-how-it-works"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-how-it-works__steps-list').forEach(function(list) {
    var steps = list.querySelectorAll('.product-how-it-works__step');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          steps.forEach(function(step) {
            step.classList.add('is-visible');
          });

          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(list);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var mainImage = document.getElementById('product-main-image');
    if (!mainImage) return;

    var img = mainImage.querySelector('.product-page__image');
    if (!img) return;

    var thumbs = document.querySelectorAll('.product-page__thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (src) img.src = src;

        thumbs.forEach(function (t) { t.classList.remove('product-page__thumb--active'); });
        thumb.classList.add('product-page__thumb--active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-for-every-age"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.stories-card').forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.45, rootMargin: '-40px 0px' });
    document.querySelectorAll('.stories-card').forEach(function (card) {
      observer.observe(card);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-theme-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.innerWidth < 769) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cards = document.querySelectorAll('.story-theme-grid__card');
    if (!cards.length) return;

    var holdDuration = 380;
    var gapDuration  = 120;

    function runSequence(index) {
      if (index >= cards.length) return;

      cards[index].classList.add('is-active');

      setTimeout(function () {
        cards[index].classList.remove('is-active');
        setTimeout(function () {
          runSequence(index + 1);
        }, gapDuration);
      }, holdDuration);
    }

    setTimeout(function () {
      runSequence(0);
    }, 600);
  })();

  (function () {
    if (window.innerWidth >= 769) return;

    var cards = document.querySelectorAll('.story-theme-grid__card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('is-touched'); });
        card.classList.add('is-touched');
      });
    });
  })();

  (function () {
    if (window.innerWidth >= 769) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var cards = document.querySelectorAll('.story-theme-grid__card');
    if (!cards.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        observer.unobserve(card);
        setTimeout(function () {
          card.classList.add('is-visible');
          setTimeout(function () {
            card.classList.add('is-done');
          }, 800);
        }, 100);
      });
    }, { threshold: 0.5 });

    cards.forEach(function (card) { observer.observe(card); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storybook-transformation"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.storybook__comparison').forEach(function(comparison) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.disconnect();
        }
      });
    }, {threshold: 0.35, rootMargin: "0px 0px -20% 0px"});

    observer.observe(comparison);
  });

  document.querySelectorAll('.storybook__steps-list').forEach(function(list) {
    var steps = list.querySelectorAll('.storybook__step');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          steps.forEach(function(step) {
            step.classList.add('is-visible');
          });

          observer.disconnect();
        }
      });
    }, {threshold: 0.3});

    observer.observe(list);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support"]) return;
  try {
    
  (function() {
    var textarea = document.getElementById('contact-message');
    var counter = document.querySelector('.support-form__counter');
    var dropdowns = document.querySelectorAll('.support-card__dropdown');
    var linksCard = document.querySelector('.support-card--links');
    var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var animationDuration = 340;
    var resizeTimer = null;

    if (textarea && counter) {
      textarea.addEventListener('input', function() {
        counter.textContent = this.value.length + '/1200';
      });
    }

    function setDropdownVisualState(dropdown, isOpen) {
      dropdown.open = isOpen;
      dropdown.classList.toggle('is-open', isOpen);
      dropdown.classList.remove('is-closing');
    }

    function stabilizeLinksCardHeight() {
      if (!linksCard || !dropdowns.length) return;

      var states = Array.prototype.map.call(dropdowns, function(dropdown) {
        return {
          open: dropdown.open,
          isOpen: dropdown.classList.contains('is-open'),
          isClosing: dropdown.classList.contains('is-closing')
        };
      });

      linksCard.classList.add('is-measuring');
      linksCard.style.minHeight = '';

      var maxHeight = linksCard.getBoundingClientRect().height;

      dropdowns.forEach(function(dropdown) {
        dropdowns.forEach(function(otherDropdown) {
          setDropdownVisualState(otherDropdown, false);
        });

        setDropdownVisualState(dropdown, true);
        maxHeight = Math.max(maxHeight, linksCard.getBoundingClientRect().height);
      });

      dropdowns.forEach(function(dropdown, index) {
        dropdown.open = states[index].open;
        dropdown.classList.toggle('is-open', states[index].isOpen);
        dropdown.classList.toggle('is-closing', states[index].isClosing);
      });

      linksCard.style.minHeight = Math.ceil(maxHeight) + 'px';
      linksCard.classList.remove('is-measuring');
    }

    function finishClose(dropdown) {
      if (dropdown.classList.contains('is-open')) return;

      dropdown.open = false;
      dropdown.classList.remove('is-closing');
    }

    function closeDropdown(dropdown, onClosed) {
      window.clearTimeout(Number(dropdown.dataset.closeTimer));
      dropdown.classList.remove('is-open');

      if (!dropdown.open || reduceMotionQuery.matches) {
        finishClose(dropdown);
        if (onClosed) {
          onClosed();
        }
        return;
      }

      dropdown.classList.add('is-closing');
      dropdown.dataset.closeTimer = String(window.setTimeout(function() {
        finishClose(dropdown);
        if (onClosed) {
          onClosed();
        }
      }, animationDuration));
    }

    function openDropdown(dropdown) {
      window.clearTimeout(Number(dropdown.dataset.closeTimer));
      dropdown.open = true;
      dropdown.classList.remove('is-closing');

      window.requestAnimationFrame(function() {
        dropdown.classList.add('is-open');
      });
    }

    function closeOtherDropdowns(activeDropdown, onClosed) {
      var openDropdowns = Array.prototype.filter.call(dropdowns, function(dropdown) {
        return dropdown !== activeDropdown && dropdown.classList.contains('is-open');
      });

      if (!openDropdowns.length) {
        onClosed();
        return;
      }

      var remaining = openDropdowns.length;

      openDropdowns.forEach(function(dropdown) {
        closeDropdown(dropdown, function() {
          remaining -= 1;

          if (!remaining) {
            onClosed();
          }
        });
      });
    }

    stabilizeLinksCardHeight();
    window.addEventListener('load', stabilizeLinksCardHeight);
    window.addEventListener('resize', function() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(stabilizeLinksCardHeight, 150);
    });

    dropdowns.forEach(function(dropdown) {
      var summary = dropdown.querySelector('summary');

      if (dropdown.open) {
        dropdown.classList.add('is-open');
      }

      if (!summary) return;

      summary.addEventListener('click', function(event) {
        event.preventDefault();

        var shouldOpen = !dropdown.classList.contains('is-open');

        if (shouldOpen) {
          closeOtherDropdowns(dropdown, function() {
            openDropdown(dropdown);
          });
        } else {
          closeDropdown(dropdown);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
